import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';

import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/zoom`;

export const ACTION_TYPES = {
  FETCH_ZOOM_LIST: 'zoom/FETCH_ZOOM_LIST',
  UPDATE_ZOOM: 'zoom/UPDATE_ZOOM',
  UPDATE_ZOOM_REFRESH: 'zoom/UPDATE_ZOOM_REFRESH',
  FETCH_USER_LIST: 'zoom/FETCH_USER_LIST',
  RESET: 'zoom/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const zoomReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_USER_LIST):
    case REQUEST(ACTION_TYPES.UPDATE_ZOOM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_USER_LIST):
    case FAILURE(ACTION_TYPES.UPDATE_ZOOM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_USER_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.users,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.UPDATE_ZOOM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        loading: false,
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default zoomReducer;

// ACTIONS

export const getToken = () => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ZOOM,
    payload: axios.get(`${apiUrl}/auth/token`),
    meta: { successMessage: `Berhasil mengambil token!` },
  });
  return result;
};

export const getUserZoom = () => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.FETCH_USER_LIST,
    payload: axios.get(`${apiUrl}/user?size=50`),
  });
  return result;
};

export const generateToken = (entity) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ZOOM,
    payload: axios.post(`${apiUrl}/auth/token?code=${entity}`),
    meta: { successMessage: `Berhasil mengambil token!` },
  });
  return result;
};

export const getTokenRefresh = () => async dispatch => {
    const result = await dispatch({
      type: ACTION_TYPES.UPDATE_ZOOM,
      payload: axios.post(`${apiUrl}/auth/token/from_refresh`),
      meta: { successMessage: `Berhasil refresh token!` },
    });
    return result;
  };

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
